import { z } from 'zod';

export const RequestNewDatasourceSchemaValues = z.object({
  vendor: z.string().optional(),
  product: z.string().optional(),
  path: z.string().optional(),
});

export type RequestNewDatasourceSchemaType = z.infer<
  typeof RequestNewDatasourceSchemaValues
>;
